$(document).ready(function() {
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
      .val('')
      .trigger('change');
    }
  }


  // Slider code
  var $materialsDiscoverSlider = $('.Product__Slideshow').flickity({
    wrapAround: false,
    autoplay:true,
    prevNextButtons: true,
    pageDots: true,
    adaptiveHeight: true,
    draggable:true,
    freeScroll: false,
    contain: true
  });

  $('.Product__Slideshow').append(' <div class="carousel-tracker"><span class="carousel-tracker-bar"></span></div>');

  $materialsDiscoverSlider.on( 'scroll.flickity', function( event, progress ) {
    //progress = Math.max( 0, Math.min( 1, progress ) );
    // $progressBar.width( progress * 100 + '%' );
    console.log(event,progress);
    carouselProgress();

  });



  function carouselProgress(){
    var $slide_width;
    var $slideNumber = ($(".Product__Slideshow.bottom .Product__SlideItem").length);
    var $leftBlock = 100 / $slideNumber;
    $slide_width = $leftBlock + '%';
    $('.Product__Slideshow.bottom ol.flickity-page-dots').find('.Product__Slideshow.bottom li.dot.is-selected').css( 'width', $slide_width);

    // $(this).find('.Product__Slideshow.bottom .flickity-page-dots');
    var currentIndex = $('.Product__Slideshow.bottom ol li.dot.is-selected').index();
    var $newLeftVal = $slideNumber*$leftBlock *(currentIndex) + '%';
    $slide_width = $leftBlock + '%'

    $('.carousel-tracker-bar ').css( 'transform' , 'translateX('+$newLeftVal+')' );
    $('.carousel-tracker-bar ').css( 'width', $slide_width);


  }


  setTimeout(function(){
    function RecomendProgress(){
      var $slide_width;
      var $slideNumber = ($(".bottom-like-more .Carousel__Cell").length);
      var $leftBlock = 100 / $slideNumber;
      $slide_width = $leftBlock + '%';
      $('.bottom-like-more ol.flickity-page-dots').find('.bottom-like-more li.dot.is-selected').css( 'width', $slide_width);

      // $(this).find('.Product__Slideshow.bottom .flickity-page-dots');
      var currentIndex = $('.bottom-like-more ol li.dot.is-selected').index();
      var $newLeftVal = $slideNumber*$leftBlock *(currentIndex) + '%';
      $slide_width = 20 + '%'

      $('.carousel-tracker-bar ').css( 'transform' , 'translateX('+$newLeftVal+')' );
      $('.carousel-tracker-bar ').css( 'width', $slide_width);


    }

    var recomendationSlider = $('.bottom-like-more').flickity({
      wrapAround: false,
      autoplay:true,
      prevNextButtons: true,
      pageDots: true,
      adaptiveHeight: true,
      draggable:true,
      freeScroll: false,
      contain: true,
      groupCells: true
    });

    $('.bottom-like-more').append(' <div class="carousel-tracker"><span class="carousel-tracker-bar"></span></div>');

    recomendationSlider.on( 'scroll.flickity', function( event, progress ) {
      console.log(event,progress);
      RecomendProgress()

    });
  }, 2000);

  // End slider code

});



let productSectionSettings = $("[data-section-id='product-template']").data("section-settings");

if($("body").hasClass("template-product") && productSectionSettings.hideDefaultVariant) {

  $(document).on("click", ".ProductForm__AddToCart[type=button]", function(e) {
    e.preventDefault();

    let $form = $(this).closest("form");;

    let variantId = $form.find('[name="id"]').val();
    if(variantId) {

      $(this).attr("type", "submit");
    } else {

      $form.find(".cart_add_error").removeClass("hide");

    }

  });
}


$(document).on('click', '.close-upsell-popup', function(e) {


  if(typeof upside === "object" && typeof upside.ucd === "object" && upside.ucd.isActive()){

    upside.ucd.helpers.ajaxCart.show(upside.ucd.helpers.ajaxCart.load);

  }$('[data-drawer-id="sidebar-cart"][data-action="open-drawer"]')[0].click();$(this).closest("#modal-upsell").attr("aria-hidden", true).removeAttr("tabindex");
  $("html").removeClass("no-scroll");
  $(".PageOverlay").removeClass("is-visible");
});

$('h2.Footer__Title.Heading.u-h6').click(function() { 
  $(this).toggleClass('active'); $(this).parent('.Footer__Block').toggleClass('active');
});

$(window).on("product:added", function(e) {

  let detail = e.originalEvent.detail;


  var t = this;

  let showSideDrawer = false;
  let $addToCartButton = $(detail.addToCartButton);
  if( $addToCartButton.closest( '.upsell-item ' ).length > 0 ) {
    $addToCartButton.closest( '.upsell-item' ).addClass( 'itemInCart' );
    showSideDrawer = false;
  }


  let $mainAddToCartButton = $addToCartButton.closest('form.ProductForm').find('.upsell-popup-enabled');

  if(($mainAddToCartButton.length) && (!($("#modal-upsell").find(".upsell-item.itemInCart").length === $("#modal-upsell").data("upsell-count") ))) {

    $("#modal-upsell").attr("aria-hidden", false).attr("tabindex", -1);

    $("html").addClass("no-scroll");
    $(".PageOverlay").addClass("is-visible"); 

  } else {

    if($("#modal-upsell[aria-hidden=true]").length){
      showSideDrawer = true;
    }
  }

  if(showSideDrawer) upside.ucd.helpers.ajaxCart.show(upside.ucd.helpers.ajaxCart.load)

    }); 

window.addEventListener("Upside::UCD::CartUpdated", function(e){

  let details = e.detail;

  let updates = Object.values(details.updates)[0];

  let variantDetails = Object.keys(updates);

  let variantDetail = variantDetails[0];
  let variantId = variantDetail.split(":")[0];

  variantId = parseInt(variantId, 10);

  let $itemToRemove = $(".remove-item[data-variant-id='"+variantId+"']");

  if( $itemToRemove.closest('.upsell-item ').length > 0 ) {
    $itemToRemove.closest( '.upsell-item' ).removeClass( 'itemInCart' );
  }

});

$(".SectionHeader__Heading.SectionHeader__Heading").click(function(){
  $(".product-information-container").toggleClass("information-show");
});     



$( document ).ready( function(){
  if($('section.Product').hasClass("enable-sticky")){
    $.fn.isInViewport = function() {
       didScroll = true;
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + ($(this).outerHeight() - $(this).innerHeight() - 81);
      var viewportTop = $(window).scrollTop() - 81 ;
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    ;

    $(window).on('resize scroll', function() {
       
      if (!$('.template-product .cart-btn-wrapper').isInViewport()) {
        $('.template-product .cart-btn-wrapper').addClass('cartBtnStickyHeightFixActive');
      } else {
        $('.template-product .cart-btn-wrapper').removeClass('cartBtnStickyHeightFixActive');
      }
    });
  
  $(window).scroll();

    $(document ).on( 'click', '.custom-product-details h2.section-title', function(){
    //console.log($(this).next('.content'))
    $(this).next('.tabs-wrapper').toggleClass("tab-active");
    $(this).toggleClass("active");

  });
}
});




$('.promise-bar-slider').flickity({
    wrapAround: false,
    autoplay:true,
    prevNextButtons: true,
    pageDots: true,
    adaptiveHeight: true,
    draggable:true,
    freeScroll: false,
    contain: true,
   	watchCSS: true,
  	pageDots: false
  });
